import { HttpErrorMessageMap } from '../types/http-error.type';

/**
 * Messages `ErrorInterceptor` rethrows in place of the `HttpErrorResponse`.
 * Read these through `httpErrorMessage()` rather than indexing the map, so a
 * caller never has to know which errors vary by action.
 */
export const HTTP_ERROR_MESSAGES: HttpErrorMessageMap = {
  forbidden: {
    view: 'You are not authorized to view this page.',
    perform: 'You are not authorized to perform this action.',
  },
  unauthorized: 'You do not have the credentials.',
  notFound: 'Resource not found.',
  contentBlocked:
    'Some characters in your input are not supported. Please remove them and try again.',
};
